import { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import type { CalendarSelections } from '@wix/bookings-catalog-calendar-viewer-utils';
import { ServiceOptionsAndVariants } from '@wix/ambassador-bookings-catalog-v1-service-options-and-variants/types';
import { SelectedVariantOptions } from '../../types/types';
import {
  getVariantByChoiceIdAndOptionId,
  isServiceVariantWithStaff,
} from '../dynamicPricing/dynamicPricing';

export const initializeSelectedVariantsOptions = ({
  calendarSelections,
  servicesInView,
  serviceVariantsMap,
}: {
  calendarSelections?: CalendarSelections;
  servicesInView: Service[];
  serviceVariantsMap: Record<string, ServiceOptionsAndVariants>;
}): SelectedVariantOptions[] => {
  if (!calendarSelections?.services?.length || !servicesInView.length) {
    return [];
  }

  const firstCalendarSelectionService = calendarSelections.services[0];
  const currentService = servicesInView[0];
  const payment = currentService.payment!;
  const serviceVariants = serviceVariantsMap[currentService.id!];

  if (!firstCalendarSelectionService.variants?.length || !serviceVariants) {
    return [];
  }

  const selectedVariantsOptions: SelectedVariantOptions[] = [];

  firstCalendarSelectionService.variants.forEach((calendarVariant) => {
    const choices = calendarVariant.choices || [];

    if (choices.length === 0) {
      return;
    }

    const firstChoice = choices[0];
    const optionId = firstChoice.optionId;
    const numberOfParticipants = calendarVariant.numberOfParticipants || 1;

    if (!optionId) {
      return;
    }

    let choiceId = '';

    if (isServiceVariantWithStaff(serviceVariants)) {
      choiceId = firstChoice.staffMemberId || '';
    } else {
      choiceId = firstChoice.custom || firstChoice.id || '';
    }

    if (!choiceId) {
      return;
    }

    const matchedVariant = getVariantByChoiceIdAndOptionId(
      serviceVariants,
      choiceId,
      optionId,
    );

    const price = matchedVariant?.price || payment.varied?.defaultPrice!;

    selectedVariantsOptions.push({
      price,
      numberOfParticipants,
      choices: matchedVariant?.choices || [
        isServiceVariantWithStaff(serviceVariants)
          ? { optionId, staffMemberId: choiceId }
          : { optionId, custom: choiceId },
      ],
    });
  });

  return selectedVariantsOptions;
};
